import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      id="notFound"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 200px)",
        textAlign: "center",
        p: 2,
      }}
    >
      <Typography variant="h3" sx={{ mb: 2 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 4 }}>
        Сторінку не знайдено
      </Typography>
      <Button
        variant="contained"
        sx={{
          background: "#f5c33d",
          color: "rgba(0, 0, 0, 0.84) !important",
        }}
        onClick={() => navigate("/")}
      >
        Повернутися на головну
      </Button>
    </Box>
  );
}
